<template>
    <div class="overflow-x-auto overscroll-x-none lg:h-screen">
        <slot />
    </div>
</template>

<script setup lang="ts">
    useHead({
        htmlAttrs: {
            class: () => {
                return {
                    'no-sentry': true,
                    'zoomed-layout': true,
                };
            },
        },
    });
</script>

<style lang="postcss">
    .no-sentry #sentry-feedback {
        @apply !hidden;
    }

    .zoomed-layout {
        font-size: 20px;
    }
</style>
